import { render, staticRenderFns } from "./BookingExtra.vue?vue&type=template&id=117da6d9&scoped=true"
import script from "./BookingExtra.vue?vue&type=script&lang=js"
export * from "./BookingExtra.vue?vue&type=script&lang=js"
import style0 from "./BookingExtra.vue?vue&type=style&index=0&id=117da6d9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117da6d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117da6d9')) {
      api.createRecord('117da6d9', component.options)
    } else {
      api.reload('117da6d9', component.options)
    }
    module.hot.accept("./BookingExtra.vue?vue&type=template&id=117da6d9&scoped=true", function () {
      api.rerender('117da6d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/components/BookingHeader/BookingExtra.vue"
export default component.exports